import { useQuery } from '@tanstack/react-query';
import { userInfoQuery } from '@frodo/lib/services/http/client/api-account.client';
import { userTypeStr } from '@frodo/lib/utils/common/helper';

export const useCustomerInfo = () => {
  const { data: user } = useQuery({
    ...userInfoQuery(),
  });

  return {
    isB2B: !!user?.isB2B,
    type: userTypeStr(user?.isB2B),
    oppositeType: userTypeStr(!user?.isB2B),
    isAuthenticated: !!user?.isAuthenticated,
    customerNumber: user?.number,
    cartItemCount: user?.cartItemCount ?? 0,
    isSoftLogin: user?.isSoftLogin ?? false,
  };
};
